export default {
  meta: {
    title: '踩点分析详情',
    parentPath: ['/car'],
    url: '/car/footprintingpanel', // 埋点用，记录所属模块
    breadcrumbs: {
      path: ['/car/footprintingpanel'],
      name: ['踩点数据面板'],
    },
  },
};
